import {
    RESET_INTERVIEW_DATA,
    SCHEDULED_INTERVIEW_LIST,
    SCHEDULED_INTERVIEW_COUNT,
    INTERVIEW_STATUS_TOGGLE
 } from '../constant/actionTypes';
  
 const INIT_STATE = {
    scheduled_interview_list : [],
    scheduled_interview_count: 0,
    interview_status_toggle: false
 };
 
 export default (state = INIT_STATE, action) => {
    switch (action.type) {
       case RESET_INTERVIEW_DATA:
          return INIT_STATE;
       case SCHEDULED_INTERVIEW_LIST:
          return {
             ...state,
             scheduled_interview_list: action.payload,
          };
       case SCHEDULED_INTERVIEW_COUNT:
          return {
             ...state,
             scheduled_interview_count: action.payload,
          };
       case INTERVIEW_STATUS_TOGGLE:
          return {
             ...state,
             interview_status_toggle: action.payload,
          };
       default:
          return state;
    }
 };